var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHourglassTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M13.3334 12.5001L20 19.1667L26.6667 12.5001V6.66675H13.3334V12.5001Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M13.3334 12.5001L20 19.1667L26.6667 12.5001V6.66675H13.3334V12.5001Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 3.33337H10V13.3334L16.6667 20L10.0167 26.6834L10 36.6667H30L29.9833 26.6834L23.3333 20L30 13.35V3.33337ZM26.6667 27.5V33.3334H13.3333V27.5L20 20.8334L26.6667 27.5ZM26.6667 12.5L20 19.1667L13.3333 12.5V6.66671H26.6667V12.5Z",
    fill: "url(#paint2_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 13.3334,
    y1: 6.66675,
    x2: 27.9215,
    y2: 17.4728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#675CE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4840A4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 13.3334,
    y1: 6.66675,
    x2: 27.9215,
    y2: 17.4728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#675CE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4840A4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 10,
    y1: 3.33337,
    x2: 38.8757,
    y2: 15.365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#675CE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4840A4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglassTop);
export default __webpack_public_path__ + "static/media/hourglass_top.0ecf1b60314a98d4f6c6c4e42116b1d8.svg";
export { ForwardRef as ReactComponent };